
<img src="../../../assets/images/check-green.gif">
<div class="align">
    <h1 style="color: rgb(3, 207, 3);">New Vendor Created Successfully</h1>
    <p><span class="shown_name"></span> Please complete the vendor profile.
        <br>Once the profile completion your vendor id
        will be activated.
    </p>
</div>

<div class="buttonRow">
    <button mat-raised-button class="button" (click)="onNoClick()" (click)="onClick()">
        <span class="material-symbols-outlined">person_add</span>
        Proceed To Complete Profile</button>
    <button mat-raised-button type="button" color="basic" class="buttonReset" type="button" [routerLink]="['/All/vendors']" (click)="onNoClick()" style="margin-left: 10px;">Close</button>
  </div>